export default __webpack_public_path__ + "static/media/resume-with-bg.6efc9da0.svg";